import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteEscalationTatConfig,
  fetchDisputeCategories,
  fetchEscalationSettings,
  fetchEscalationTatConfigs,
  upsertEscalationTatConfig,
} from "../../../services/disputeEscalationConfigService";

export const fetchEscalationTatConfigsThunk = createAsyncThunk(
  "disputeEscalationConfig/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchEscalationTatConfigs();
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch TAT configs");
    }
  }
);

export const upsertEscalationTatConfigThunk = createAsyncThunk(
  "disputeEscalationConfig/upsert",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response = await upsertEscalationTatConfig(payload);
      dispatch(fetchEscalationTatConfigsThunk());
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to save TAT config");
    }
  }
);

export const deleteEscalationTatConfigThunk = createAsyncThunk(
  "disputeEscalationConfig/delete",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      await deleteEscalationTatConfig(id);
      dispatch(fetchEscalationTatConfigsThunk());
      return id;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to delete TAT config");
    }
  }
);

export const fetchEscalationSettingsThunk = createAsyncThunk(
  "disputeEscalationConfig/fetchSettings",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchEscalationSettings();
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch settings");
    }
  }
);

export const fetchDisputeCategoriesThunk = createAsyncThunk(
  "disputeEscalationConfig/fetchCategories",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchDisputeCategories();
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch categories");
    }
  }
);
